import { useEffect, useId, useRef, useState } from 'react';
import { Consumer, Subscription } from '@rails/actioncable';
import { Win } from './types';

export const WIDGET_SHOW_TIMEOUT = 10000;

const useWins = (): [Win | undefined, boolean, () => void] => {
  const [subscription, setSubscription] = useState<Subscription>();
  const [win, setWin] = useState<Win>();
  const [opened, setOpened] = useState(false);
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);
  const channelId = useId();

  useEffect(() => {
    const cable = window.cable as Consumer;
    const sub: Subscription = cable.subscriptions.create(
      {
        channel: 'JackpotAggregator::WinnerWinsChannel',
        channelId,
      },
      {
        connected: () => {
          sub.perform('notify');
        },
        received: (v) => {
          setWin((prev) => (timer.current ? prev : v));
        },
      }
    );

    setSubscription(sub);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
        sub.perform('notify'); // trigger notification for other components on the page
      }
      sub.unsubscribe();
    };
  }, []);

  const onClick = () => {
    setOpened((prev) => {
      if (prev) {
        setWin(undefined);
        return false;
      }

      timer.current = setTimeout(() => {
        setWin(undefined);
        setOpened(false);
        timer.current = undefined;
        subscription?.perform('notify');
      }, WIDGET_SHOW_TIMEOUT);

      subscription?.perform('see', { id: win?.id });
      return true;
    });
  };

  return [win, opened, onClick];
};

export default useWins;
